import { render, staticRenderFns } from "./ProjectsSingle.vue?vue&type=template&id=1eb7ef2c&"
import script from "./ProjectsSingle.vue?vue&type=script&lang=js&"
export * from "./ProjectsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports